<template>
    <div class="image-view-wrapper">
        <div class="image-view-content">
            <img :src="data.url" alt="" class="image-view-image" />
            <Icon :width="36" :height="36" :iconUrl="iconUrl" class="image-view-close" @iconClick="close" />
        </div>
    </div>
</template>

<script>
import Icon from "@/views/zhiji/bComponents/icons/Icon";

export default {
    name: "ImageViewModal",
    props: ["data"],
    components: {
        Icon
    },
    data() {
        return {
            iconUrl: this.zhiji.staticPath() + "view_close.png"
        };
    },
    methods: {
        close() {
            this.$emit("closeModal");
        }
    }
};
</script>

<style scoped lang="less">
.image-view-wrapper {
    width: 100%;
    height: 100%;
    background-color: rgba(18, 22, 37, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 1330px;
    min-height: 760px;
    .image-view-content {
        position: relative;
        .image-view-image {
            max-width: 1280px;
            max-height: 720px;
        }
        .image-view-close {
            position: absolute;
            top: -50px;
            right: -40px;
            z-index: 1;
        }
    }
}
</style>
